import React from 'react';
import c from '../assets/c.png';
import cpp from '../assets/cpp.png';
import dsa from '../assets/data-structure.png'
import html from '../assets/html.png';
import css from '../assets/css.png';
import javascript from '../assets/javascript.png';
import reactImage from '../assets/react.png';
import nodejs from '../assets/nodejs.png';
import github from '../assets/github.png';
import mysql from '../assets/mysql.png';
import mongodb from '../assets/mongodb.png'
import tailwind from '../assets/tailwind.png';

const Experience = () => {
    const techs = [
        {
            id:1,
            src: c,
            title:'C',
            style:'shadow-blue-500'
        },
        {
            id:2,
            src: cpp,
            title:'C++',
            style:'shadow-blue-400'
        },
        {
            id:3,
            src: dsa,
            title:'DSA',
            style:'shadow-gray-200'
        },
        {
            id:4,
            src: html,
            title:'HTML',
            style:'shadow-orange-500'
        },
        {
            id:5,
            src: css,
            title:'CSS',
            style:'shadow-blue-300'
        },
        {
            id:6,
            src: javascript,
            title:'JavaScript',
            style:'shadow-yellow-500'
        },
        {
            id:7,
            src: reactImage,
            title:'React',
            style:'shadow-blue-600'
        },
        {
            id:8,
            src: tailwind,
            title:'Tailwind',
            style:'shadow-sky-400'
        },
        {
            id:9,
            src: nodejs,
            title:'Node JS',
            style:'shadow-green-300'
        },
        {
            id:10,
            src:mysql,
            title:'mySQL',
            style:'shadow-blue-300'
        },
        {
            id:11,
            src: mongodb,
            title:'mongodb',
            style:'shadow-green-500'
        },
        {
            id:12,
            src: github,
            title:'GitHub',
            style:'shadow-gray-400'
        }
    ]
  return (
    <div name='experience' className='bg-gradient-to-b from-black to-gray-800 w-full h-screen'>
        <div className='max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full text-white'>
            <div>
                <p className='text-4xl font-bold border-b-4 border-gray-500 p-2 inline'>Experience</p>
                <p className='py-6 text-xl'>These are the technologies I've worked with</p>
            </div>
            <div className='w-full grid grid-cols-3 sm:grid-cols-3 sm:gap-3 gap-1 text-center py-8 px-2 sm:px-12 lg:grid-cols-4'>
                {
                    techs.map(({id, src, title, style})=>(
                        <div key={id} className={`shadow-md hover:scale-105 duration-500 py-2 rounded-lg ${style}`}>
                            <img src={src} alt="" className='w-20 mx-auto' />
                            <p className='mt-4'>{title}</p>
                        </div>
                    ))
                }
                
            </div>
        </div>
    </div>
  )
}

export default Experience